import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { getMachine, updateMachine } from '@/apis/machines'
import routes from '@/constants/routes'
import useNotification from '@/hooks/useNotification'
import { GetMachineRequest } from '@/types/apis/machines/GetMachineRequest'
import { GetMachineResponse } from '@/types/apis/machines/GetMachineResponse'
import { UpdateMachineRequest } from '@/types/apis/machines/UpdateMachineRequest'
import { UpdateOperatorResponse } from '@/types/apis/operators/UpdateOperatorResponse'

export const useUpdateMachines = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const openNotification = useNotification()
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<UpdateOperatorResponse>()

  const update = useCallback(
    async (request: UpdateMachineRequest) => {
      try {
        setLoading(true)
        const res = await updateMachine(request)
        setResponse(res)
        openNotification({ type: 'success', description: t('components.pages.admins.common.update.success') })
        navigate(routes.machines.path)
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.update.fail') })
      } finally {
        setLoading(false)
      }
    },
    [navigate, openNotification, t]
  )

  return {
    loading,
    updateMachine: update,
    response,
  }
}

export const useGetMachine = () => {
  const [loading, setLoading] = useState(false)
  const [response, setResponse] = useState<GetMachineResponse>()

  const get = useCallback(async (request: GetMachineRequest) => {
    try {
      setLoading(true)
      const res = await getMachine(request)
      setResponse(res)
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    getMachine: get,
    response,
  }
}
